const SELECT_SELECTOR = [
    'select:not([multiple])',
    ':not([data-native-select])',
    ':not(.select2-hidden-accessible)'
].join('');

const WOO_REFRESH_EVENTS = [
    'updated_checkout',
    'updated_wc_div',
    'updated_cart_totals',
    'updated_shipping_method',
    'wc_fragments_refreshed',
    'country_to_state_changed',
    'found_variation',
    'reset_data'
].join(' ');

function getSelectWoo() {
    if (!window.jQuery) {
        return null;
    }

    const $ = window.jQuery;

    return typeof $.fn.selectWoo === 'function' ? $ : null;
}

function decorateContainer($select) {
    const $container = $select.next('.select2-container');

    if ($container.length) {
        $container.addClass('myl-custom-select');
    }
}

function decorateOpenDropdown($) {
    $('.select2-container--open .select2-dropdown')
        .last()
        .addClass('myl-custom-select-dropdown');
}

function initializeSelects(context = document) {
    const $ = getSelectWoo();

    if (!$) {
        return;
    }

    const $context = $(context);
    const $selects = $context.is('select')
        ? $context.filter(SELECT_SELECTOR)
        : $context.find(SELECT_SELECTOR);

    $selects.each(function initializeSelect() {
        const $select = $(this);

        if ($select.attr('size') && Number($select.attr('size')) > 1) {
            return;
        }

        if (!$select.hasClass('select2-hidden-accessible')) {
            $select.selectWoo({
                width: '100%',
                minimumResultsForSearch: $select.is('[data-custom-select-search]') ? 0 : Infinity,
                dropdownCssClass: 'myl-custom-select-dropdown'
            });
        }

        decorateContainer($select);

    });

    $('select.select2-hidden-accessible').each(function decorateWooSelect() {
        decorateContainer($(this));
    });

    $(document.body)
        .off('select2:open.mylCustomSelect', 'select')
        .on('select2:open.mylCustomSelect', 'select', () => decorateOpenDropdown($));
}

function scheduleInitialization(context = document) {
    window.setTimeout(() => initializeSelects(context), 0);
}

document.addEventListener('DOMContentLoaded', () => {
    scheduleInitialization(document);
});

if (window.jQuery) {
    window.jQuery(document.body).on(WOO_REFRESH_EVENTS, (event) => {
        scheduleInitialization(event.target || document);
    });
}
